import map from "lodash/map";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { ProfileAvatarConnected } from "PFApp/components/profile_avatar_connected";
import { Inline, Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { ProfileMinimized } from "PFCore/types";
import { useTranslation } from "react-i18next";

export const ActivityWatchers = () => {
  const { watchers } = useCurrentActivity();

  const { t } = useTranslation("activities", { keyPrefix: "show.details.watchers" });

  return (
    <Stack qaId="ActivitySummary-Watchers">
      <Typography variant="bodyBold">{t("title")}</Typography>
      {/* fixme make the Profile inline component */}
      {map(watchers, (watcher) => (
        <Inline alignItems="center" gap="spacingSm" key={watcher.id}>
          <ProfileAvatarConnected profile={watcher.profile as unknown as ProfileMinimized} size={24} />
          <Typography variant="bodyButtons">{getProfileName(watcher)}</Typography>
        </Inline>
      ))}
    </Stack>
  );
};
